import axios from 'axios';
import {v4} from 'uuid';
import {ApiRequest, ApiResponse} from '../CommonInterfaces';
import {
  GetPastDueRequest,
  GetWaveTemplatesRequest,
  GetWaveTemplatesResponse,
  WaveTemplate,
  WaveTemplateBatchRequest,
  WaveTemplateBatchResponse
} from '../../warehouse/batch-waving/wave-templates/WaveTemplateInterfaces';
import * as BatchWaving from '../../warehouse/ecommerce-batches/BatchInterfaces';
import InternalAPIService from './InternalAPIService';

class WaveTemplateService extends InternalAPIService {
  constructor(authenticityToken: string) {
    super(authenticityToken, '/wh/wave_template');
  }

  public async getPastDue(
    warehouseId: number,
    currentDate: string,
    currentDateTime: string
  ): Promise<ApiResponse<GetWaveTemplatesResponse>> {
    let query: GetPastDueRequest;
    if (currentDate) {
      query = {
        warehouseId,
        currentDate
      };
    } else {
      query = {
        warehouseId,
        currentDateTime
      };
    }

    return this.makeGetRequest(`${this.baseUrl}/past_due_shipments`, query);
  }

  /**
   * Fetch all wave templates for a warehouse.
   * @param waveTemplateIds ID of the templates to fetch.
   * @param shipByDate
   * @param useexactShipOnDates if true, use the "exactShipOnDates" parameter instead of "shipByDate" to get only
   * shipments with the specified ship by date, otherwise uses the "all dates up to cutoff date" behavior.
   */
  public async fetchWaveTemplates(
    waveTemplateIds: number[],
    shipByDate: string,
    useexactShipOnDates: boolean
  ): Promise<ApiResponse<WaveTemplateBatchResponse>> {
    const data: WaveTemplateBatchRequest = {waveTemplateIds};
    if (useexactShipOnDates) {
      data.exactShipOnDates = [shipByDate];
    } else {
      data.shipByDate = shipByDate;
    }
    const requestParameters: ApiRequest<WaveTemplateBatchRequest> = {
      authenticity_token: this.authenticityToken,
      data,
      meta: {
        correlationId: v4()
      }
    };
    try {
      const response = await axios.post(`${this.baseUrl}s`, requestParameters);
      return response.data as ApiResponse<WaveTemplateBatchResponse>;
    } catch (error) {
      return this.handleErrorResponse(error);
    }
  }
}

export default WaveTemplateService;
